import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { AuthRepository } from '@timechef/core/auth';
import { NavBarAction } from '@timechef/core/models/app';
import { AppRepository } from '@timechef/core/state';
import { isNullOrUndefined } from '@timechef/core/utils/js-utils';
import { RestaurantsService } from '@timechef/features/restaurants/state';
import { MenuPopoverComponent } from '../../components/menu-popover/menu-popover.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderComponent {
  currentSite$ = this.authRepo.currentSite$;
  userWithCashRegister$ = this.authRepo.userWithCashRegister$;
  accountNavBarItemNotif$ = this.appRepo.accountNavBarItemNotif$;
  activeAccountNavBarItem$ = this.appRepo.activeAccountNavBarItem$;
  showReloadTextInHeader$ = this.appRepo.reloadEnabledButNoSpaceOnNavBar$;

  constructor(
    private appRepo: AppRepository,
    private authRepo: AuthRepository,
    private restaurantsService: RestaurantsService,
    private popover: PopoverController,
  ) {}

  hasBalanceAlert(balanceData?: number) {
    if (isNullOrUndefined(balanceData)) return false;

    const balanceAlert = this.authRepo.getBalanceAlert();
    return balanceAlert.userAmount ? balanceAlert.userAmount > balanceData : balanceAlert.siteAmount > balanceData;
  }

  async openMenu(e: Event) {
    const popover = await this.popover.create({
      component: MenuPopoverComponent,
      event: e,
      componentProps: { items: this.appRepo.getActiveNavBarItems(), onItemClick: (a: NavBarAction) => this.triggerAction(a) },
    });

    await popover.present();

    await popover.onDidDismiss();
  }

  async triggerAction(action: NavBarAction) {
    if (action === 'OPEN_SURVEY') {
      await this.restaurantsService.openSurveyCampaignModal({ openCurrentRestaurant: true });
    }
  }
}
